module.exports = __webpack_public_path__ + "img/index-other-bg.0247d78b.png";